import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../App';
import { useAuth } from '../../AuthContext';
import { AlertTriangle, TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function WeakSubjectBanner() {
  const { user, token } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [weak, setWeak] = useState(null);
  const isEN = language === 'en';

  useEffect(() => {
    if (!token) return;
    const check = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/stats/me`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) return;
        const data = await res.json();
        if (data.avg_accuracy < 60 && data.total_matches > 2) {
          setWeak({ accuracy: data.avg_accuracy });
        }
      } catch (e) {}
    };
    check();
  }, [token]);

  if (!weak) return null;

  return (
    <div className="weak-subject-banner" data-testid="weak-subject-banner">
      <AlertTriangle size={18} />
      <span>
        {isEN
          ? `Your accuracy is ${weak.accuracy}%. Try Practice Mode to improve!`
          : `Ketepatan anda ${weak.accuracy}%. Cuba Mod Latihan untuk tingkatkan!`}
      </span>
      <button onClick={() => navigate('/practice-setup')}>
        <TrendingUp size={14} /> {isEN ? 'Practice Now' : 'Latih Sekarang'}
      </button>
    </div>
  );
}
